$(document).ready(function () {

    var activePlantSelect = $('#active-plant-select');

    activePlantSelect.select2({width: '100%'});
    activePlantSelect.on('change', function (e) {
        var selectedOption = activePlantSelect.find(':selected');
        var selectedUrl = selectedOption.data('url');
        window.location.replace(selectedUrl);
        // todo: I don't think this is necessary. It is creating duplicate GET requests in the activity logs but it may have been put here for a reason.
        // $.get(selectedUrl, function () {
        //     location.reload();
        // });
    });

});
